// @flow

import {
    GET_PROJECT_DRAWING_SUMMARY_FAILURE,
    GET_PROJECT_DRAWING_SUMMARY_REQUEST,
    GET_PROJECT_DRAWING_SUMMARY_SUCCESS
} from "../actions/actionTypes";
import type { ProjectDrawingSummaryState } from "../typeDefinitions/reduxState/projectDrawingSummaryState";
import type { ProjectDrawingAction } from "../typeDefinitions/actions/projectDrawingSummaryActions";

const initialState: ProjectDrawingSummaryState = {
    isFetching: false,
    numberOfFacets: null,
    actualSquares: null,
};

const projectDrawingSummary = (state: ProjectDrawingSummaryState = initialState, action: ProjectDrawingAction) => {
    switch (action.type) {
        case GET_PROJECT_DRAWING_SUMMARY_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            });
        case GET_PROJECT_DRAWING_SUMMARY_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                ...action.response,
            });
        case GET_PROJECT_DRAWING_SUMMARY_FAILURE:
            return Object.assign({}, initialState);
        default:
            return state;
    }
};

export default projectDrawingSummary;
